// extracted by mini-css-extract-plugin
export default {"archivedItems":"archivedItems-MjNtg","table":"table-efGCR"};